import type { Fetch } from '../types'

const contentTypeKey = 'Content-Type' as const
export function configDefaultContentTypeFactory(contentType: string) {
  return function configDefaultContentType(nextFetch: Fetch): Fetch {
    return function (input: RequestInfo | URL, init?: RequestInit) {
      if (init?.noDefaultContentType === true) {
        return nextFetch(input, init)
      }
      const headersInit: HeadersInit = init?.headers ?? new Headers({ [contentTypeKey]: contentType })
      if (headersInit instanceof Headers) {
        if (headersInit.has(contentTypeKey) === false) {
          headersInit.append(contentTypeKey, contentType)
        }
      } else if (Array.isArray(headersInit)) {
        if (headersInit.some(([header, _]) => header === contentTypeKey) === false) {
          headersInit.push([contentTypeKey, contentType])
        }
      } else {
        if (!headersInit[contentTypeKey]) {
          headersInit[contentTypeKey] = contentType
        }
      }
      init = { ...init, headers: headersInit }
      return nextFetch(input, init)
    }
  }
}

